import { ReactComponent as Eye } from '../../assets/svgs/eye.svg';
import { ReactComponent as ViewIcon } from '../../assets/svgs/eye.svg';
import HeaderCell from '../../components/table/HeaderCell';
import { formatCurrency } from '../../utils/formatCurrency';

const getStatusColor = status => {
  switch (status) {
    case 'Completed':
      return '#E4FAEE';
    case 'Pending':
      return '#FFD6D6';
    case 'In Progress':
      return '#DCF5FF';
    default:
      return 'gray.100';
  }
};

const getStatusTextColor = status => {
  switch (status) {
    case 'Completed':
      return '#157E36';
    case 'Pending':
      return '#FF0000';
    case 'In Progress':
      return '#115995';
    default:
      return 'gray.100';
  }
};

const columns = ({ onViewPaymentOpen }) => [
  {
    name: <HeaderCell label={'PAYMENT ID'} />,
    selector: row => row?.id, // Using `id` as SKU
  },
  {
    name: <HeaderCell label={'DATE'} />,
    selector: row => {
      if (!row?.date_created) return '';
      const date = new Date(row.date_created);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    width: '300px',
  },

  {
    name: <HeaderCell label={'SELLER NAME'} />,
    selector: row => `${row?.payee_id?.first_name} ${row?.payee_id?.surname}`,
  },
  {
    name: <HeaderCell label={'PAYMENT AMOUNT'} />,
    selector: row => formatCurrency(row.amount),
  },
  {
    name: <HeaderCell label={'PAID FROM BANK'} />,
    selector: row => `${row.paidFromBank}`,
  },
  {
    name: <HeaderCell label={'ACTION'} />,
    cell: row => (
      <Eye
        width={20}
        height={20}
        cursor={'pointer'}
        onClick={() => onViewPaymentOpen(row)}
      />
    ),
  },
];

const data = [
  {
    bag_id: '123',
    id: 1,
    product_name: '500',
    brand_name: '12/06/2025',
    location: 'London',
    status: 'Pending',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 2,
    product_name: '300',
    brand_name: '13/06/2025',
    location: 'Manchester',
    status: 'Completed',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 3,
    product_name: '900',
    brand_name: '14/06/2025',
    location: 'Birmingham',
    status: 'In Progress',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 4,
    product_name: '600',
    brand_name: '15/06/2025',
    location: 'Liverpool',
    status: 'Pending',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 5,
    product_name: '100',
    brand_name: '16/06/2025',
    location: 'Leeds',
    status: 'Pending',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 6,
    product_name: '450',
    brand_name: '17/06/2025',
    location: 'Sheffield',
    status: 'Completed',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 7,
    product_name: '650',
    brand_name: '18/06/2025',
    location: 'Bristol',
    status: 'In Progress',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 8,
    product_name: '420',
    brand_name: '19/06/2025',
    location: 'Newcastle',
    status: 'Pending',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 9,
    product_name: '550',
    brand_name: '20/06/2025',
    location: 'Nottingham',
    status: 'Pending',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 10,
    product_name: '250',
    brand_name: '21/06/2025',
    location: 'Leicester',
    status: 'In Progress',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 11,
    product_name: '100',
    brand_name: '22/06/2025',
    location: 'Cambridge',
    status: 'Pending',
    website_link: 'https://www.google.com',
  },
  {
    bag_id: '123',
    id: 12,
    product_name: '200',
    brand_name: '23/06/2025',
    location: 'Oxford',
    status: 'In Progress',
    website_link: 'https://www.google.com',
  },
];

export { data, columns };
